import K from '../constants';
import restHelpers from '../helpers/restHelper';

//groups with vehicle
const getGroupsFn = () => restHelpers.withBearer.get(`${K.API_URL}/groups`, {});

const createGroupFn = (name, description, phoneNumber) => restHelpers.withBearer.post(`${K.API_URL}/groups`, { data: { name, description, phoneNumber } });

const updateGroupFn = (groupId, name, description, phoneNumber) => restHelpers.withBearer.put(`${K.API_URL}/groups/${groupId}`, { data: { name, description, phoneNumber } });

const addGroupVehiclesFn = (groupId, ...vehiclesId) => restHelpers.withBearer.put(`${K.API_URL}/cars/group/${groupId}`, { data: { carId: [...vehiclesId] } });

const removeGroupVehiclesFn = (...vehiclesId) => restHelpers.withBearer.put(`${K.API_URL}/cars/group`, { data: { carId: [...vehiclesId] } });

const deleteGroupFn = groupId => restHelpers.withBearer.delete(`${K.API_URL}/groups/${groupId}`);

const deleteGroupVehicleFn = (groupId, vehicleId) => restHelpers.withBearer.delete(`${K.API_URL}/groups/${groupId}/${vehicleId}`);

const getAllGroupsFn = () => restHelpers.withBearer.get(`${K.API_URL}/all-groups`, {});

const getCountsFn = (filters) => restHelpers.withBearer.post(`${K.API_URL}/cars/get-groups-count?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}`, { data: filters });

export default {
  getGroups: getGroupsFn,
  createGroup: createGroupFn,
  updateGroup: updateGroupFn,
  addGroupVehicles: addGroupVehiclesFn,
  removeGroupVehicles: removeGroupVehiclesFn,
  deleteGroup: deleteGroupFn,
  deleteGroupVehicle: deleteGroupVehicleFn,
  getAllGroups: getAllGroupsFn,
  getCounts: getCountsFn
};



// WEBPACK FOOTER //
// ./src/services/groups.js